export const faqs = [
  {
    question: "How do I book a tour package?",
    answer:
      "Booking a tour package is simple! Browse our packages, select your preferred destination, choose your travel dates, and click 'Book Now'. You can also contact our travel experts who will guide you through the entire booking process and customize the package according to your preferences.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept UPI, credit cards, debit cards and net banking.",
  },
  {
    question: "Can I customize my tour package?",
    answer:
      "Yes, all our packages can be customized according to your needs.",
  },
  {
    question: "What is your cancellation policy?",
    answer:
      "Cancellation charges depend on the time of cancellation and package terms.",
  },
];
